<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col l4 s12">
        <ul class="about hide-on-small-only">
          <li><router-link :to="{ name: 'ViewProfile', params: { id: this.name }} ">プロフィール</router-link></li>
          <li><router-link :to="{ name: 'AddContent' }">部屋の作成</router-link></li>
          <li><router-link :to="{ name: 'SearchContent' }">部屋を探す</router-link></li>
        </ul>
      </div>
      <div class="col l8 s12">
          <p class="grey-text text-darken-1">部屋一覧</p>
          <div v-for="content in contents">
            <div class="talkcard card-panel">
              <span class="content-title"><router-link class="blue-text" :to="{ name: 'Content', params: { slug: content.title }} ">{{ content.title }}</router-link></span>
              </br>
              <span class="description grey-text text-darken-1">{{ content.description }}</span>
              </br>
              <span class="picked grey-text text-lighten-1">{{ content.picked }}</span>
            </div>
          </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'
import moment from 'moment'

export default {
  name: 'Home',
  data(){
    return{
      user: null,
      name: null,
      alias: null,
      content: null,
      contents: [],
      title: null,
      picked: null,
      time: null
    }
  },
  created(){

    let ref = db.collection('users')
    let user = firebase.auth().currentUser

    // current user
    ref.where('user_id', '==', user.uid).get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        this.user = doc.data()
        this.name = doc.id
      })
    });

    db.collection('contents').get()
    .then(snapshot =>{
      snapshot.forEach(doc =>{
        let content = doc.data()
        content.id = doc.id
        this.contents.push(content)
      })
    })
  }
}
</script>

<style>
.talkcard{
  margin-top: 0px;
  margin-bottom: 0px;
  max-width: 600px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 5px;
  padding-left: 10px;
}
.content-title{
  font-size: 1.4em;
  margin-top: 5px;
  margin-bottom: 5px;

}
.description{
  font-size: 1.0em;
}
.picked{
  font-size: 0.8em;
}
.home{
margin-top:50px;
}
.about{
  font-size: 1.2em;
}
h4{
 margin-top: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue